import './App.css';
import Content from './components/Content';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
import { Route, Routes } from 'react-router-dom';
import  Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    })
  }, [])
  return (
      <div>
        <Routes>
          <Route path='/' element={[<Hero />, <Content />]} />
          <Route path='portfolio' element={<Portfolio />} />
        </Routes>
      </div>
  );
}

export default App;
